import React, { useState, useEffect, useCallback } from "react";
import { addDays } from "date-fns";
import { Pie } from "react-chartjs-2";
import CustomDatePicker from "./datepicker";
import { ChartTitle, Subtitle, PieChartWrapper, colors } from "./styles";
import { useQueryReport } from "../hooks/useQueryReport";
import { Card, CardBody, CardHeader, CardTitle, Table } from "reactstrap";

const PivotTable = (props) => {
    const INITIAL_STATE = {
        labels: [],
        values: [],
        colors: [],
    };
    const [reportData, setReportData] = useState([]);
    const [startDate, setStartDate] = useState(addDays(new Date(), -10));
    const [endDate, setEndDate] = useState(new Date());
    const [totalUsers, setTotalUsers] = useState(0);

    const { fetchData } = useQueryReport();

    const displayResults = useCallback(
        (response) => {
            console.log(response);
            const queryResult = response.reports[0].rows;
            // const total = response.reports[0].data.totals[0].values[0];
            // setTotalUsers(total);


            setReportData(prev => (queryResult));
        },
        []
    );

    const data = {
        labels: reportData.labels,
        datasets: [
            {
                data: reportData.values,
                backgroundColor: reportData.colors,
            },
        ],
    };

    const options = {
        legend: { position: "bottom" },
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                font: {
                    size: 0,
                },
            },
        },
    };

    useEffect(() => {
        const request = {
            viewID: props.viewID,
            startDate,
            endDate,
            metrics: "screenPageViews",
            dimensions: ["Eventname", "deviceModel", "Country", "dayOfWeek"],
        };
        setTimeout(
            () =>
                fetchData(request)
                    .then((resp) => displayResults(resp))
                    .catch((error) => console.error(error)),
            1500
        );
    }, [displayResults, endDate, fetchData, props.viewID, startDate]);
    // console.log(reportData);

    return (
        <div>
            <Card className="shadow-lg border rounded">
                <CardHeader>
                    <CardTitle tag="h4">Page/Screen Tracking of Users</CardTitle>
                </CardHeader>
                <CardBody>
                    <Table className="tablesorter" responsive>
                        <thead className="text-primary">
                            <tr>
                                <th>Page View Name</th>
                                <th>Device Name</th>
                                <th>Country</th>
                                <th>Day Of Week</th>
                                <th className="text-center">Page Views</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportData?.map((table) => (

                                    <tr>
                                        <td>{table.dimensionValues[0].value}</td>
                                        <td>{table.dimensionValues[1].value}</td>
                                        <td>{table.dimensionValues[2].value}</td>
                                        <td>{table.dimensionValues[3].value}</td>
                                        <td className="text-center">{table.metricValues[0].value}</td>
                                    </tr>))
                            }


                        </tbody>
                    </Table>
                </CardBody>
            </Card>
            {/* {reportData && (
        <PieChartWrapper>
          <Pie data={data} options={options} width={300} height={300} />
        </PieChartWrapper>
      )} */}
        </div>
    );
};

export default PivotTable;
